module.exports = __webpack_public_path__ + "img/DNADamage-CRC_10X_WTA.544b6e7e.png";